/**
 * Validates that a value is a phone number. Useful in forms where
 * a user is entering a phone number.
 *
 * @param input value from input field
 * @returns undefined if input is a valid phone number
 * @returns an error message if input is not a valid phone number
 */
export const validatePhoneInput = (input: string) => {
  const regex = /^\d{3}-\d{3}-\d{4}$/
  return regex.test(input) ? undefined : 'Please enter a valid phone number'
}
